export const getProduct = state => state.product.product;
export const getLoading = state => state.product.loading;
export const getProductFail = state => state.product.error
export const getCare = state => state.product.care;
export const getComposition = state => state.product.composition;
export const getIsSentByColor = state => state.product.isSentByColor;